/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";

export const BtnIconArrow = ({ color = "#0066FF", className }) => {
  return (
    <svg
      className={`btn-icon-arrow ${className}`}
      fill="none"
      height="25"
      viewBox="0 0 25 25"
      width="25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M12.6895 5.96387V19.9639M12.6895 19.9639L5.68945 12.9639M12.6895 19.9639L19.6895 12.9639"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};

BtnIconArrow.propTypes = {
  color: PropTypes.string,
};
